/**
 * Which top-nav tab owns the current venue URL.
 * Nested routes (Food Safety section, a stock take, Purchasing sub-pages)
 * must keep their parent tab selected — antd Menu otherwise sticks on the
 * previous tab (Success Hub after an FS deep link from the Hub).
 */

export const VENUE_TOP_NAV_ROUTE_KEYS = Object.freeze([
  'home',
  'purchasing',
  'food-safety',
  'stockTakes',
  'menu-builder',
  'special-purchases',
  'progress',
  'suppliers',
  'catalogue',
  'products',
  'approvals',
  'settings',
  'subscriptions',
  'integrations',
])

const SETTINGS_TAB_KEYS = new Set(['settings', 'subscriptions', 'integrations'])

/**
 * @param {string|null|undefined} pathname
 * @returns {string}
 */
export function venueTopNavSelectedKey(pathname) {
  const fragments = String(pathname || '')
    .split('/')
    .filter(Boolean)
  for (const key of VENUE_TOP_NAV_ROUTE_KEYS) {
    if (!fragments.includes(key)) continue
    if (SETTINGS_TAB_KEYS.has(key)) return 'settings'
    return key
  }
  return fragments[fragments.length - 1] || ''
}
